<template>
  <div class="kp-flat-card small-shadow p-20  mb-30">
    <toggle-filters @filterChanged="randomize"></toggle-filters>
    <div class="featured-value">
      <h4>€24,475</h4>
      <p>Highest peak</p>
    </div>
    <div class="income-outcome-chart">
      <apexchart type=line height=280 :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script>
import ToggleFilters from '@/components/dashboard/ToggleFilters.vue'

export default {
  name: 'income-outcome',
  components: {
    ToggleFilters
  },
  methods: {
    rand(min, max) {
      return Math.round(Math.floor(Math.random() * (max - min + 1)) + min)
    },
    randomize() {
      const self = this
      const newSeries = []
      this.series.forEach((series, index) => {
        const newSeriesData = series.data.map((el) => Math.floor(self.rand(12300, 25000)))
        newSeries.push({
          name: series.name,
          data: newSeriesData
        })
      })
      this.series = newSeries
    }
  },
  data() {
    return {
      series: [
        {
          name: 'Incoming',
          data: [14475, 18145, 17123, 21352, 18485, 20898, 14145]
        },
        {
          name: 'Outgoing',
          data: [12315, 19123, 21124, 24475, 17412, 13761, 13964]
        }
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        colors: ['#ef781d', '#545454'],
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        grid: {
          borderColor: '#cfcfcc',
          strokeDashArray: 5,
          padding: {
            top: 40
          }
        },
        xaxis: {
          categories: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            style: {
              fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
            }
          }
        },
        yaxis: {
          show: false,
          min: 10000,
          max: 25000,
          tickAmount: 5,
          axisBorder: {
            show: false
          },
          crosshairs: {
            show: false
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
          markers: {
            width: 24,
            height: 3,
          }
        }
      }
    }
  }
}
</script>
